import cloneDeep from "lodash/cloneDeep";

class LootTable {
  constructor(v) {
    this.id = v.id;
    this.items = v.items;
  }

  hasItems(){
    return this.items.length > 0 ? true : false;
  }

  dropDistinctItemsFromTable (amount) {
    if (!this.hasItems()) { return []; } // quit early if there are no items

    let itemsList = [];
    let newDropsList = cloneDeep(this.items);
    if (this.items.length <= amount) {
      return newDropsList;
    } else {
      for (let i=0; i<amount; i++) {
        let randomNumber = Math.random();
        let itemIndex = Math.floor(randomNumber * newDropsList.length)
        let item = cloneDeep(newDropsList[itemIndex]);
        //console.log("Adding ", item, " to choices");
        itemsList.push(item);
        newDropsList.splice(itemIndex, 1);
        //console.log(randomNumber, itemIndex, item, itemsList, newDropsList)
      }
    }
    return itemsList
  }
}

export default LootTable;
